import React, { useState } from 'react';
import omit from 'lodash/omit';
import startCase from 'lodash/startCase';
import shortid from 'shortid';
import {
  Field,
  ErrorMessage,
} from 'formik';

const FormCheckGroup = (props) => {
  const {
    label,
    name,
    className,
    asSwitch = false,
  } = props;
  const [id] = useState(() => `a${shortid.generate()}`);
  const p = {
    id,
    ...omit(props, ['label', 'asSwitch']),
    className: [
      className,
      asSwitch ? 'custom-control-input' : 'form-check-input',
    ].filter((s) => s).join(' '),
  };

  return (
    <div className={
        asSwitch
          ? 'custom-control custom-switch'
          : 'form-check'
      }>
      <Field {...p} />
      {label !== null && (
        <label
          htmlFor={id}
          className={asSwitch ? 'custom-control-label' : 'form-check-label'}>
          {label === undefined ? startCase(name) : label}
        </label>
      )}
      <ErrorMessage name={name}>
        {(msg) => (
          <div className="invalid-feedback">{msg}</div>
        )}
      </ErrorMessage>
    </div>
  );
};

export default FormCheckGroup;
